import {
  UpdateEmailConfigMetadataPayload,
  useRestApiProvider,
} from "@jugl-web/rest-api";
import { useToast, useTranslations } from "@jugl-web/utils";
import { useCallback } from "react";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { useEmailAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/EmailAccountProvider/useEmailAccount";

export const useUpdateEmailSettings = () => {
  const { entityId } = useEntitySelectedProvider();
  const { emailAccount } = useEmailAccount();
  const { integrationsApi } = useRestApiProvider();
  const { toast } = useToast();
  const { t } = useTranslations();
  const [updateEmailConfig, { isLoading }] =
    integrationsApi.useUpdateEmailConfigMutation();

  const updateEmailSettings = useCallback(
    async ({
      ai_reply,
      metadata,
    }: {
      ai_reply?: boolean;
      metadata?: UpdateEmailConfigMetadataPayload;
    }) => {
      try {
        await updateEmailConfig({
          entityId,
          data: {
            ai_reply,
            metadata: metadata
              ? { ...emailAccount?.metadata, ...metadata }
              : undefined,
          },
          meta: { silent: true },
        }).unwrap();
        toast(
          t({
            id: "client-support-page.email-inbox-settings-updated",
            defaultMessage: "Email Inbox settings was updated",
          })
        );
        return true;
      } catch {
        toast(
          t({
            id: "feedback.something-went-wrong",
            defaultMessage: "Something went wrong",
          }),
          { variant: "error" }
        );
        return false;
      }
    },
    [emailAccount?.metadata, entityId, t, toast, updateEmailConfig]
  );

  return { updateEmailSettings, isUpdatingEmailSettings: isLoading };
};
